import ArtistCarousel from './ArtistCarousel';

export default ArtistCarousel;
